/* src/app/share-user-guides/share-user-guides.component.scss */
form {
  width: 500px;
  margin: 0 auto;
  text-align: left;
  background: #3d3f47;
  padding: 20px;
  border-radius: 20px;
  color: white;
}
form #emails {
  height: 150px;
}
.custom-select {
  height: auto;
  padding: 15px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 400;
  color: #222222;
  background-color: #FDFDFD;
  border: 1px solid #312BC6;
  width: 100%;
}
/*# sourceMappingURL=share-user-guides.component.css.map */
